import { ConfigTypeOverride } from '@cp/shared/config';
import { ConfigManager } from 'src/shared/config';

export const registerServiceWorker = async (config: ConfigManager<ConfigTypeOverride>) => {
  if (typeof window !== 'undefined' && 'serviceWorker' in window.navigator) {
    const buildId = config.get('BUILD_ID');
    await navigator.serviceWorker.register(buildId ? `/sw.js?v=${buildId}` : '/sw.js');
  }
};
